export enum AcceptanceStateEnum {
  Undefined = 0,
  /// <summary>
  /// Aceptada Tacitamente
  /// </summary>
  TacitlyAccepted = 21,
  /// <summary>
  /// Aceptada por cliente
  /// </summary>
  AcceptedByCustomer = 22,
  /// <summary>
  /// Rechazada por cliente
  /// </summary>
  RejectedByCustomer = 23,
  /// <summary>
  /// Rechazada por usuario
  /// </summary>
  RejectedByUser = 24,
  /// <summary>
  /// Aceptado por usuario
  /// </summary>
  AcceptedByUser = 25,
}
export enum TestSetStatusEnum {
  /// <summary>
  /// En espera de set id
  /// </summary>
  NoStart = 0,
  /// <summary>
  /// Esperando por envio desde un doc desde el ERP
  /// </summary>
  WaitForFirstDocument = 1,
  /// <summary>
  /// Esperando la validacion del primer documento
  /// </summary>
  FirstDocumentInValidation = 2,
  /// <summary>
  /// Estado de ERROR debe enviarse otro documento
  /// </summary>
  FirstDocumentRejected = 3,
  /// <summary>
  /// primer documento aceptado, se esta generando el set
  /// </summary>
  RepliesGenerationProcess = 4,
  /// <summary>
  /// Esperando por la validacion de las replicas, se finalizo generacion
  /// </summary>
  WaitingForConfirmReplies = 5,
  /// <summary>
  /// Estado de ERROR debe reintentarse el envio
  /// </summary>
  OneOrMoreDocsNoConfirmed = 6,
  /// <summary>
  /// Esperando conformacion por parte del usuario
  /// </summary>
  WaitForUserConfirm = 7,
  /// <summary>
  /// Set de pruebas finalizado
  /// </summary>
  Sucess = 8,
}

export enum SendTypeEnum {
  /// <summary>
  /// ambiente de habilitacion
  /// </summary>
  enable = 0,
  /// <summary>
  /// factura de ambiente productivo
  /// </summary>
  production = 1,
  /// <summary>
  /// factura de pruebas en ambiente productivo
  /// </summary>
  productiontest = 2,
}

export enum EmailStateAcquirerEnum {
  Undefined = 0,
  /// <summary>
  /// Enviada
  /// </summary>
  SendEmail = 11,
  /// <summary>
  /// Correo invalido
  /// </summary>
  InvalidEmail = 12,
  /// <summary>
  /// Correo bloqueado
  /// </summary>
  BlockedEmail = 13,
  /// <summary>
  /// Envío fallido
  /// </summary>
  FailedShipping = 14,
}

export enum ProcessResultCode {
  /// <summary>
  /// Documento en proceso de envio
  /// </summary>
  InProcess = 0,
  /// <summary>
  /// Proceso terminado en proceso de validacion
  /// </summary>
  SendSuccessInValidationProcess = 1,
  /// <summary>
  /// Proceso terminado aprobado por la dian
  /// </summary>
  SendSuccessApproved = 2,
  /// <summary>
  /// Proceso terminado aprobado con notificaciones
  /// </summary>
  SendSuccessApprovedWithWarnings = 3,
  /// <summary>
  /// Proceso terminado rechazado por la dian
  /// </summary>
  SendSuccessRejected = 4,
  /// <summary>
  /// Rechazado por PT
  /// </summary>
  PTRejected = 5,
  /// <summary>
  /// Pendiente de envio por contingencia
  /// </summary>
  PendingToSendContingency = 6,
  /// <summary>
  /// Documento aprobado previamente
  /// </summary>
  PreviousApproved = 7,
  /// <summary>
  /// La DIAN no dio respuesta definitiva (ocupada, vacia o timeout), pendiente de verificacion
  /// </summary>
  PendingDianVerification = 8,

  //EmailStateAcquirerEnum
  /// <summary>
  /// Enviada
  /// </summary>
  SendEmail = 11,
  /// <summary>
  /// Correo invalido
  /// </summary>
  InvalidEmail = 12,
  /// <summary>
  /// Correo bloqueado
  /// </summary>
  BlockedEmail = 13,
  /// <summary>
  /// Envío fallido
  /// </summary>
  FailedShipping = 14,

  //AcceptanceStateEnum
  /// <summary>
  /// Aceptada Tacitamente
  /// </summary>
  TacitlyAccepted = 21,
  /// <summary>
  /// Aceptada por cliente
  /// </summary>
  AcceptedByCustomer = 22,
  /// <summary>
  /// Rechazada por cliente
  /// </summary>
  RejectedByCustomer = 23,
  /// <summary>
  /// Rechazada por usuario
  /// </summary>
  RejectedByUser = 24,
  /// <summary>
  /// Aceptado por usuario
  /// </summary>
  AcceptedByUser = 25,

  /// <summary>
  /// PDFCargado satisfactoriamente
  /// </summary>
  PdfUploadSuccess = 30,
  /// <summary>
  /// Error en cargue de pdf
  /// </summary>
  PdfUploadError = 31,

  /// <summary>
  /// Errores durante adaptacion
  /// </summary>
  AdapterError = 100,
  /// <summary>
  /// Errores durante la generacion del XML
  /// </summary>
  LoadDataError = 200,
  /// <summary>
  /// Errores durante la generacion del XML
  /// </summary>
  XmlGenerateError = 300,
  /// <summary>
  /// Errores durante el firmado
  /// </summary>
  SignError = 400,
  /// <summary>
  /// Errores durante el envio o comunicacion con la dian
  /// </summary>
  DianSendError = 500,
  /// <summary>
  /// Rechazos por parte de la DIAN
  /// </summary>
  DianResultError = 600,
}

export enum EmailSendType {
  /// <summary>
  /// No se realiza envio de email
  /// </summary>
  None = 0,
  /// <summary>
  /// Automaticamente luego del cargue de la representacion grafica
  /// </summary>
  Automatic = 1,
  /// <summary>
  /// A solicitud del usuario mediante el api de General
  /// </summary>
  WithRequest = 2,
  /// <summary>
  /// A solicitud del usuario mediante el api de General y automatico al cargue de pdf
  /// </summary>
  AutomaticAndWithRequest = 3,
}

export enum PayrollDocumentType {
  /// <summary>
  /// Nómina individual
  /// </summary>
  Individual = 102,
  /// <summary>
  /// Nota de ajuste de nómina individual
  /// </summary>
  Adjustment = 103,
}

export enum TypeDocumentEnum
    {
        /// <summary>
        /// Factura de venta
        /// </summary>
        InvoiceSale = 1,
        /// <summary>
        /// Factura de exportación
        /// </summary>
        InvoiceExport = 2,
        /// <summary>
        /// Factura de contingencia
        /// </summary>
        InvoiceContingency = 3,
        /// <summary>
        /// Factura electrónica de venta -tipo 04 
        /// </summary>
        InvoiceSaleFourType = 4,
        /// <summary>
        /// Documento soporte
        /// </summary>
        DocumentSupport= 5,
        /// <summary>
        /// Documento equivalente para servicios publicos domiciliarios
        /// </summary>
        EquivalentDocumentSPD = 60,
        /// <summary>
        /// Nota crédito
        /// Exclusivo en referencias de documentos (DocumentReference)
        /// </summary>
        CreditNote = 91,
        /// <summary>
        /// Nota débito
        /// Exclusivo en referencias de documentos (DocumentReference)
        /// </summary>
        DebitNote = 92,
        /// <summary>
        /// Nota debito de ajuste a documento equivalente
        /// </summary>
        EquivalentDocumentDebitNote = 93,
        /// <summary>
        /// Nota credito de ajuste a documento equivalente
        /// </summary>
        EquivalentDocumentCreditNote = 94,
        /// <summary>
        /// Attached Document
        /// Exclusivo en referencias de documentos (DocumentReference)
        /// </summary>
        AttachedDocument = 100,
        /// <summary>
        /// Nota de Ajuste
        /// Exclusivo para documento soporte
        /// </summary>
        AdjustmentNote = 95
    }